import { Calendar } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconCalendar12Line = createIcon(Calendar, 12, "Line");
export const IconCalendar16Line = createIcon(Calendar, 16, "Line");
export const IconCalendar20Line = createIcon(Calendar, 20, "Line");
export const IconCalendar24Line = createIcon(Calendar, 24, "Line");
export const IconCalendar32Line = createIcon(Calendar, 32, "Line");
export const IconCalendar48Line = createIcon(Calendar, 48, "Line");
export const IconCalendar64Line = createIcon(Calendar, 64, "Line");
